import React from "react";
import { type RenderLeafProps } from "slate-react";

const ContentLeaf = ({ attributes, children, leaf }: RenderLeafProps) => {
  if (leaf.bold) {
    children = <strong>{children}</strong>;
  }

  if (leaf.code) {
    children = <code>{children}</code>;
  }

  if (leaf.italic) {
    children = <em>{children}</em>;
  }

  if (leaf.underline) {
    children = <u>{children}</u>;
  }

  if (leaf.strikethrough) {
    children = <s>{children}</s>;
  }

  const style = React.useMemo(
    (): React.CSSProperties | undefined => (leaf.color ? { color: leaf.color } : undefined),
    [leaf.color]
  );

  return (
    <span style={style} {...attributes}>
      {children}
    </span>
  );
};
export default ContentLeaf;
